export class SubHeaderTag {
    public value: string;
    public icon: string;

    constructor(icon: string, value: string) {
        this.value = value;
        this.icon = icon;
    }
}